module.exports = __webpack_public_path__ + "static/media/company_logo.c59ceea5.svg";